import {actions} from './actions';
import {mapCluster, PAGE_SIZE, sortBy} from '../../utils';


const formatValue = (key, value) => {
    if (!value) {
        return '';
    }

    if (key === 'openHouse') {
        return value ? 'Yes' : 'No';
    } else if (key === 'keyword') {
        return value.join(' | ');
    } else if (key === 'listingContractDate') {
        return value.toISOString().split('T')[0];
    }

    return value;
};


const getParameters = (filter,display) => {

    const {viewport: {center, zoom}, bounds: {nelat, nelong, swlat, swlong}, activeTab, recenter, ...rest} = filter;

    const [lat,lng]=center;

    const query = rest[activeTab];

    const parameters = {recenter: recenter ? 1 : 0};

    if (nelat && nelong && swlat && swlong) {
        parameters.x1 = swlat;
        parameters.x2 = nelat;
        parameters.y1 = nelong;
        parameters.y2 = swlong;
    }

    const urlQuery = {activeTab, lat, lng, zoom,display};

    for (const [key, value] of Object.entries(query)) {

        const formattedValue = formatValue(key, value);

        if (formattedValue && key !== 'for sale' && key !== 'for rent') {
            urlQuery[key] = formattedValue;
            parameters[key.toLowerCase()] = formattedValue;
        }

        if (key === 'transactionType') {
            const price = query[formattedValue];

            if (price && price.min) {
                urlQuery.minprice = price.min;
                parameters.minprice = price.min;
            }
            if (price && price.max) {
                urlQuery.maxprice = price.max;
                parameters.maxprice = price.max;
            }
        }
    }


    return {parameters, urlQuery};
};


export const reducers = [
    [
        actions.pending,
        (state) => ({
            ...state, status: 'pending', error: null
        })
    ],
    [
        actions.rejected,
        (state) => ({
            ...state,
            property: {raw: {}, properties: [], cluster: []},
            pagination: {
                count: 0,
                currentPage: 0,
                currentProperties: []
            },
            status: 'rejected',
            error: 'No results found.'
        })
    ],
    [
        actions.fulfilled,
        (state, action) => {
            const {raw, properties, error, count} = action.payload;

            const {params: {viewport: {zoom}, bounds: {nelat, nelong, swlat, swlong}}, sort} = state;

            const result = {
                raw,
                properties: properties.sort(sortBy(sort.by, sort.order, sort.type)),
                cluster: []
            };


            if (error) {
                return {
                    ...state,
                    status: 'fulfill',
                    error,
                    property: result,
                    pagination: {
                        count,
                        currentPage: 0,
                        currentProperties: []
                    }
                };
            }

            if (nelat && nelong && swlat && swlong && zoom) {
                const superCluster = mapCluster.get();

                const temp = properties.filter((i) => !(isNaN(i.geometry.coordinates[0]) || isNaN(i.geometry.coordinates[1])));

                superCluster.load(temp);
                result.cluster = superCluster.getClusters([swlong, swlat, nelong, nelat], zoom);
            }

            const currentPage = 1;


            const offset = (currentPage - 1) * PAGE_SIZE;


            const currentProperties = properties.slice(offset, offset + PAGE_SIZE);


            return {
                ...state,
                status: 'fulfill',
                error: null,
                property: result,
                pagination: {
                    count,
                    currentPage,
                    currentProperties
                }
            };

        }
    ],
    [
        actions.init,
        (state, action) => {
            const {
                error, filters, display
            } = action.payload;

            console.log('yahooo');
            if (error) {
                return state;
            }

            const {urlQuery, parameters} = getParameters(filters,display);

            return {
                ...state,
                status: 'initial',
                display,
                params: {
                    ...filters,
                    urlQuery,
                    parameters
                }
            };
        }
    ],
    [
        actions.filterChanged,
        (state, action) => {

            const {ignore = false, ...params} = action.payload;

            let {params: {urlQuery, parameters}, property} = state;

            // const filters = deepMerge(state.params, params, {
            //     arrayMerge: (destination, source) => {
            //         if (source === null || source === undefined) {
            //             return destination;
            //         }
            //
            //         return source;
            //     }
            // });

            const filters = {...state.params, ...params};

            if (ignore) {
                filters.recenter = false;
                const {viewport: {zoom}, bounds: {nelat, nelong, swlat, swlong}} = filters;

                if (nelat && nelong && swlat && swlong && zoom) {
                    const superCluster = mapCluster.get();

                    const temp = property.properties.filter((i) => !(isNaN(i.geometry.coordinates[0]) || isNaN(i.geometry.coordinates[1])));

                    superCluster.load(temp);
                    property.cluster = superCluster.getClusters([swlong, swlat, nelong, nelat], zoom);
                }
            } else {
                ({urlQuery, parameters} = getParameters(filters,state.display));
            }

            return {
                ...state,
                status: 'initial',
                property,
                params: {
                    ...filters,
                    urlQuery,
                    parameters
                }
            };
        }
    ],
    [
        actions.sort,
        (state, action) => {
            const {params} = action.payload;

            const {property, pagination: {count}} = state;


            const sortedProperties = property.properties.sort(sortBy(params.by, params.order, params.type));

            property.properties = sortedProperties;

            const currentPage = 1;

            const offset = (currentPage - 1) * PAGE_SIZE;


            const currentProperties = sortedProperties.slice(offset, offset + PAGE_SIZE);


            return {
                ...state,
                sort: params,
                property,
                pagination: {
                    count,
                    currentPage,
                    currentProperties
                }
            };
        }
    ],
    [
        actions.viewTypeChange,
        (state, action) => {
            const {display} = action.payload;

            const filters={...state.params};

            const {urlQuery, parameters} = getParameters(filters,display);

            return {
                ...state,
                display,
                params: {
                    ...filters,
                    urlQuery,
                    parameters
                }
            };
        }
    ],
    [
        actions.pageChanged,
        (state, action) => {
            const {page} = action.payload;

            const {property: {properties}, pagination: {count}} = state;


            if (properties.length > 0) {


                const offset = (page - 1) * PAGE_SIZE;


                const currentProperties = properties.slice(offset, offset + PAGE_SIZE);


                return {
                    ...state,
                    pagination: {
                        currentPage: page,
                        count,
                        currentProperties
                    }
                };
            }

            return state;
        }
    ]
];
